import React from 'react';
import { OnboardingNav } from '../../components/Onboarding/OnboardingNav';
import { SurveyContainer } from '../../components/Survey/SurveyContainer';
import { SurveyWrapper } from '../../components/Survey/SurveyWrapper';

interface ProgramEmptyStateProps {
  onStartOver: () => void;
}

export const ProgramEmptyState: React.FC<ProgramEmptyStateProps> = ({ onStartOver }) => {
  return (
    <div className="onboarding-flow">
      <div className="onboarding-complete onboarding-survey-container">
        <SurveyContainer>
          <SurveyWrapper>
            <OnboardingNav onClick={onStartOver} />
            <div className="survey-program-preview-container">
              <div className="survey-program-header">
                <span className="survey-program-recommendation">No Program Found</span>
              </div>
              <div className="survey-error-content">
                <p className="survey-error-message" style={{ color: '#6c757d' }}>
                  We couldn&apos;t find a recommended program for you. Please start the survey
                  again.
                </p>
              </div>
            </div>
          </SurveyWrapper>
        </SurveyContainer>
      </div>
    </div>
  );
};
